module.exports = __webpack_public_path__ + "static/img-people-monitoring@3x.cf9094c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-people-monitoring@3x.png
// module id = 799
// module chunks = 199482085584678